export const errorCodes = [
    'AUTH_INVALID_CODE',
    'AUTH_INVALID_CREDENTIALS',
    'AUTH_INVALID_TOKEN',
    'CARD_NOT_CREATED',
    'CARD_NOT_FOUND',
    'CARD_STATUS_MISMATCH',
    'CASHBACK_SYNC_ERROR',
    'CONTACT_EXISTS',
    'CONTACT_NOT_FOUND',
    'DAILY_LIMIT_EXCEEDED',
    'DDR_ENABLED',
    'DDR_NOT_ENABLED',
    'DOCUMENT_CREATE_FAILED',
    'DOCUMENT_DELETE_FAILED',
    'OLD_PASSWORD',
    'DOCUMENT_NOT_FOUND',
    'DOCUMENT_UPDATE_FAILED',
    'EFT_ACCOUNT_EXISTS',
    'EFT_ACCOUNT_NOT_FOUND',
    'EMAIL_EXIST',
    'EMAIL_IS_PRIMARY',
    'EMAIL_NOT_FOUND',
    'EMAIL_NOT_VERIFIED',
    'EPS_CARD_CREATE_LINK_ERROR',
    'EPS_CARD_NOT_FOUND',
    'EPS_CARD_SET_PRIMARY_ERROR',
    'EPS_CARD_SYNC_ERROR',
    'EPS_TRANSACTION_FAILED',
    'FAILED_TO_GET_NOTIFICATION',
    'INSUFFICIENT_BALANCE',
    'INVALID_ADDRESS',
    'INVALID_CODE',
    'INVALID_CONTACT_TYPE',
    'INVALID_PHONE',
    'INVALID_SCHEDULE',
    'INVALID_TOKEN',
    'INVALID_USER_TYPE',
    'LOYALTY_AWARD_POINTS_FAILED',
    'LOYALTY_AWARD_POINTS_NOT_ENQUEUED',
    'LOYALTY_REVIEW_FAILED',
    'LOYALTY_REVIEW_NOT_ENQUEUED',
    'MISSING_INTERAC_CONTACT',
    'MISSING_SECURITY_INFO',
    'LIMITS_EXCEEDED',
    'MONTHLY_LIMIT_EXCEEDED',
    'NOTIFICATION_NOT_FOUND',
    'PAYEE_NOT_FOUND',
    'PHONE_EXIST',
    'PHONE_IS_PRIMARY',
    'PHONE_NOT_FOUND',
    'PHONE_NOT_VERIFIED',
    'PROFILE_TAG_ALREADY_TAKEN',
    'PROFILE_TAG_DOES_NOT_MATCH',
    'REQUEST_CARD_LIMIT',
    'SCHEDULE_CREATE_FAILED',
    'SCHEDULE_NOT_ENQUEUED',
    'SCHEDULE_NOT_FOUND',
    'SCHEDULE_NOT_PROCESSED',
    'SCHEDULE_UPDATE_FAILED',
    'SYSTEM_ERROR',
    'TRANSACTION_METHOD_MISMATCH',
    'TRANSACTION_NOT_CREATED',
    'TRANSACTION_NOT_FOUND',
    'TRANSACTION_STATUS_MISMATCH',
    'TRANSACTION_TYPE_MISMATCH',
    'USER_EMAIL_NOT_FOUND',
    'USER_INVALID_PASSWORD',
    'USER_NOT_FOUND',
    'USER_POST_VERIFY_ERROR',
    'USER_REGISTRATION_ERROR',
    'USER_STATUS_MISMATCH',
    'VERIFICATION_NOT_FOUND',
    'WEBHOOK_E_TRANSFER_UPDATE_FAILED',
    'WEBHOOK_E_TRANSFER_UPDATE_NOT_ENQUEUED',
    'WEBHOOK_EFT_UPDATE_FAILED',
    'WEBHOOK_EFT_UPDATE_NOT_ENQUEUED',
    'WEBHOOK_EPS_UPDATE_FAILED',
    'WEBHOOK_EPS_UPDATE_NOT_ENQUEUED',
    'WEEKLY_LIMIT_EXCEEDED',
    'TOO_MANY_REQUESTS',
    'USER_ALREADY_BLOCKED',
    'invalid_secure_code'
];
